<template>
	<div class="component-section" @click="handleClick">
		<h3 class="section-title">Landing Page Utilities Buttons</h3>
		<div class="buttons-container">
			<button class="landingpage-utilities-button" data-component-type="landingpage-utilities-button">
				<FontAwesomeIcon :icon="['far', 'link']" class="mr-2" />
				<b class="landingpage-utilities-text" data-text-only="true">EcoDesign Sharepoint</b>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faLink } from "@fortawesome/pro-regular-svg-icons"

library.add(faLink)

const emit = defineEmits<{
	(e: "elementClick", event: MouseEvent): void
}>()

const handleClick = (event: MouseEvent) => {
	emit("elementClick", event)
}
</script>

<style lang="scss" scoped>
.component-section {
	background: white;
	border-radius: 8px;
	padding: 1.5rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	margin-bottom: 1rem;
}

.section-title {
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 1rem;
	color: #374151;
	border-bottom: 2px solid #e5e7eb;
	padding-bottom: 0.5rem;
}

.buttons-container {
	display: flex;
	gap: 0.75rem;
	flex-wrap: wrap;
	align-items: center;
}

.mr-2 {
	margin-right: 0.5rem;
}

.landingpage-utilities-button {
	padding: 8px 16px;
	font-size: 14px;
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	min-width: 200px;
	background-color: var(--p-landingpage-utilities-buttons-background-color, transparent);
	color: var(--p-landingpage-utilities-buttons-text-color, #00402c);
	border: 2px solid var(--p-landingpage-utilities-buttons-text-color, #00402c);
}

.landingpage-utilities-button:hover {
	background-color: var(--p-landingpage-utilities-buttons-background-color-hover, #00402c);
	color: #ffffff;
	border-color: #ffffff;
}
</style>
